import React from "react";

// region Imports - Libraries
import { Tab, Tabs } from "@material-ui/core";
// endregion
// region Imports - Languages
import useTranslation from "src/translations/useTranslation";
import { WaterAdditionByTravelMessages } from "@shared/languages/interfaces";
// endregion
// region Imports - Components
import Header from "@components/Header";
import TabPanel from "@components/TabPanel";
import WaterAdditionHistory from "../WaterAdditionHistory";
import WaterAdditionSynthetic from "./WaterAdditionSynthetic";
// endregion
// region Imports - Hooks
import { useSelector } from "react-redux";
import usePersistedState from "@hooks/usePersistedState";
// endregion
// region Imports - Store
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";
// endregion
// region Imports - Styles
import { DefaultTheme } from "styled-components";
import light from "@styles/themes/light.theme";
import { Container } from "./styles";
// endregion

const WaterAdditionMain: React.FC = () => {

  // region States
  const [selectedTab, setSelectedTab] = React.useState(0);
  // endregion
  // region Hooks
  const { screen } = useSelector((screen) => screen);
  const [theme] = usePersistedState<DefaultTheme>("@Fleet:theme", light);
  const { t } = useTranslation();
  // endregion
  // region Functions

  /**
   * Updates the currently selected tab index.
   * @param {Object} event - The event object associated with the tab change action.
   * @param {number} newValue - The index of the newly selected tab.
   */
  const handleChangeTab = (event, newValue) => setSelectedTab(newValue);
  // endregion

  return (
    <>
      <Header title={t(WaterAdditionByTravelMessages.waterAdditionTitle)} />
      <Container platform={screen.platform as ScreenPlatform} className="page">
        <Tabs
          value={selectedTab}
          onChange={handleChangeTab}
          className="tabContainer"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.colors.primary
            }
          }}
        >
          <Tab label={t(WaterAdditionByTravelMessages.analyticTabTitle)} disableRipple />
          <Tab label={t(WaterAdditionByTravelMessages.syntheticTabTitle)} disableRipple />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          <WaterAdditionHistory hideHeader />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <WaterAdditionSynthetic />
        </TabPanel>
      </Container>
    </>
  );
};

export default WaterAdditionMain;
